import { render, staticRenderFns } from "./DlvES_Delivery_Items.vue?vue&type=template&id=33464424"
import script from "./DlvES_Delivery_Items.vue?vue&type=script&lang=js"
export * from "./DlvES_Delivery_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports